import type {
  InspectAssessmentPeriod,
  InspectAssessmentUserAssignment,
} from '../../../../state/app/inspect_assessment/types';

export type InspectAssessmentUserSelection = {
  selected: boolean;
  assignmentPeriodIndices: number[];
  latePeriodIndices: number[];
};

export type InspectAssessmentUserAssignmentIndex = Map<string, number[]>;

const assignmentKey = (newsId: number, instrumentId: number) =>
  `${newsId}:${instrumentId}`;

export const buildUserAssignmentIndex = (
  assignments: InspectAssessmentUserAssignment[],
  periods: InspectAssessmentPeriod[],
): InspectAssessmentUserAssignmentIndex => {
  const periodIndexById = new Map<number, number>();
  periods.forEach(period => {
    if (period.assessment_period) {
      periodIndexById.set(period.assessment_period.id, period.index);
    }
  });

  const periodIndicesByPair = new Map<string, Set<number>>();
  assignments.forEach(assignment => {
    if (assignment.news_id === null) return;
    const periodIndex = periodIndexById.get(assignment.period_id);
    if (periodIndex === undefined) return;
    const key = assignmentKey(assignment.news_id, assignment.instrument_id);
    const periodIndices = periodIndicesByPair.get(key) ?? new Set<number>();
    periodIndices.add(periodIndex);
    periodIndicesByPair.set(key, periodIndices);
  });

  return new Map(
    Array.from(periodIndicesByPair, ([key, periodIndices]) => [
      key,
      Array.from(periodIndices).sort((left, right) => left - right),
    ]),
  );
};

export const describeUserSelection = (
  index: InspectAssessmentUserAssignmentIndex,
  newsId: number,
  instrumentId: number | undefined,
  sourcePeriodIndex: number,
): InspectAssessmentUserSelection => {
  const assignmentPeriodIndices =
    instrumentId === undefined
      ? []
      : (index.get(assignmentKey(newsId, instrumentId)) ?? []);
  return {
    selected: assignmentPeriodIndices.length > 0,
    assignmentPeriodIndices,
    latePeriodIndices: assignmentPeriodIndices.filter(
      periodIndex => periodIndex > sourcePeriodIndex,
    ),
  };
};
